module.exports = "/static/media/oslavyadarky.b9843ebd.jpg";